"use client";
function i(t) {
  return t == null || t.hasAttribute("disabled") || t.getAttribute("aria-disabled") === "true";
}
export {
  i
};
